export const COMPLIANCE_SMS_SEND_WINDOW = {
  startHour: 8,
  endHour: 20,
} as const
